export const config = {
  api : 'https://dspizzeria-server-saichakri.vercel.app'
//   api: "http://localhost:8000",
};
